import { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Location } from "@/api/opb/opbTypes";
import { CREDIT_CARD_FEE_THRESHOLD } from "@/constants";
import { formatCurrency } from "@/utils/string";

export function CardFeeNotice({
  location,
}: {
  location?: Location;
}): ReactElement | null {
  const { t } = useTranslation("paymentMethods");
  if (location == null || location.creditCardFeeRate <= 0) return null;
  return (
    <aside className="payment-fee-notice">
      <strong>{t("Card processing fee")}</strong>
      <p>
        {t(
          "A {{rate}}% processing fee applies to card payments over {{threshold}}.",
          {
            rate: location.creditCardFeeRate,
            threshold: formatCurrency({
              value: CREDIT_CARD_FEE_THRESHOLD,
              currency: location.currencyCode,
              maximumFractionDigits: 2,
              minimumFractionDigits: 0,
            }),
          }
        )}
      </p>
    </aside>
  );
}
